<template>
	<div class="card-body">
		<div style="display: flex;justify-content: space-between;">
			<div>
				<h4 class="card-title"><a class="task-href" @click="$router.push(`/task/${task.id}/show`);">
						{{ task.title }}</a></h4>
			</div>
			<div>
				<span class="badge bg-info fs-16px cursor-pointer">{{ task.price }}<small
						class="fs-6 fw-normal ps-1">руб.</small></span>
			</div>
		</div>
		<small class="text-gray-700"> <b>{{ task.updated_at }} </b>
			<b class="pe-2">ID{{ task.id }}</b>
			<a :href="task.link" target="_blank" class="pe-2">{{ getDomain(task.link) }}</a>
		</small>
		<div class="card-text pt-2">
			<div class="row">
				<div class="col-xl-6 col-md-12 col-sm-12 col-12">
					<table>
						<tr>
							<td style="min-width:150px">Категория:</td>
							<td>{{ task.type_desc }}</td>
						</tr>
						<tr>
							<td style="min-width:150px">Дата:</td>
							<td>{{ task.updated_at }}</td>
						</tr>
						<tr>
							<td style="min-width:150px">Статус:</td>
							<td role="button" @click="$router.push(`/task/${task.id}/review`);"
								v-html="task.status_desc">
							</td>
						</tr>
					</table>
				</div>
				<div class="col-xl-6 col-md-12 col-sm-12">
					<table>
						<tr>
							<td style="min-width:150px">Осталось сделать:</td>
							<td>{{ task.count }}</td>
						</tr>
						<tr>
							<td style="min-width:150px">Всего сделано:</td>
							<td>{{ task.done }}</td>
						</tr>
						<tr>
							<td style="min-width:150px">Цена:</td>
							<td>{{ task.price }} руб.</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TaskPanel',
		props: ['task', 'stats'],
		data() {
			return {

			}
		},
		methods: {
			getDomain(url) {
				//eslint-disable-next-line
				let pattern = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/\n]+)/
				let resp = pattern.exec(url)
				return resp[1]
			}
		}
	}
</script>